export default __webpack_public_path__ + "static/media/inter.3bf0ebe5.svg";